import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from "@/components/ui/dialog.tsx";
import {Button} from "@/components/ui/button.tsx";
import React, {useState} from "react";
import {InfoIcon} from "lucide-react";


export default function ConfirmDialog(
    {
        title, description, confirm = "OK", onConfirm, children, open, onOpenChange
    }: {
        title: string;
        description?: string;
        confirm?: string;
        onConfirm: () => void;
        children?: React.ReactNode;
        open?: boolean;
        onOpenChange?: (open: boolean) => void;
    }) {

    const [internalOpen, setInternalOpen] = useState(false);
    const dialogOpen = open ?? internalOpen;
    const setDialogOpen = onOpenChange ?? setInternalOpen;

    const handleConfirm = () => {
        onConfirm();
        setDialogOpen(false);
    }

    return (
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
            {children && <DialogTrigger asChild>{children}</DialogTrigger>}
            <DialogContent className="sm:max-w-106.25 text-center">
                <DialogHeader>
                    <DialogTitle className="text-center">
                        <div
                            className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
                            <InfoIcon className="h-7 w-7 text-primary"/>
                        </div>
                        {title}
                    </DialogTitle>
                    {description &&
                        <DialogDescription className="text-center">{description}</DialogDescription>}
                </DialogHeader>
                <DialogFooter className="mt-2 sm:justify-between">
                    <DialogClose asChild>
                        <Button variant="outline">Abbrechen</Button>
                    </DialogClose>
                    <Button type="button" onClick={handleConfirm}>{confirm}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
